<template>
  <div style="width: 1500px; margin:0 auto;padding: 20px;">
    <div class="shadow">
      <div class="product-detail">
        <!-- <div class="detail-left">
          <imageView
            v-if="productDetails.images"
            :value="productDetails.images"
            style="width:160px;height: 160px;object-fit: contain;margin: auto;"
          ></imageView>
          <img
            v-else
            src="@/assets/img/home/xian.png"
            alt="图片加载中"
          >
        </div> -->
        <div class="detail-right">
          <div class="product-name">{{ productDetails.cpmc }}</div>
          <div class="info-list">
            <div class="info-item">
              <span class="info-label">年利率范围</span>
              <span class="info-value">
                <span v-if="productDetails.zxdklv && productDetails.zddklv">{{ productDetails.zxdklv }}%～{{ productDetails.zddklv }}%</span>
                <span v-else-if="productDetails.zxdklv && !productDetails.zddklv">{{ productDetails.zxdklv }}%以上</span>
                <span v-else-if="!productDetails.zxdklv && productDetails.zddklv">{{ productDetails.zddklv }}%以下</span>
              </span>
            </div>
            <div class="info-item">
              <span class="info-label">贷款期限</span>
              <span class="info-value">{{ productDetails.dkqx }}个月</span>
            </div>
            <div class="info-item">
              <span class="info-label">贷款额度</span>
              <span class="info-value">{{ productDetails.dked }}万</span>
            </div>
            <div class="info-item">
              <span class="info-label">担保方式</span>
              <span class="info-value">{{ productDetails.dbfs }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">信贷类型</span>
              <span class="info-value">{{ productDetails.xdlx }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">联系人及联系电话</span>
              <span class="info-value">{{ productDetails.lxrxm }} {{ productDetails.lxrdh }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">所属机构</span>
              <span class="info-value">{{ productDetails.qymc }}</span>
            </div>
          </div>
          <!-- <div class="detail-btn">
            <span @click="goApply(productDetails.id)">立即申请</span>
          </div> -->
        </div>
      </div>
    </div>
        <div class="detail-word">
        <div class="detail-name">产品详情</div>
        <div v-html="productDetails.rzyt">
        </div>
      </div>
  </div>
</template>
<script>
import { getNeedsDetail, getHotSells, applyProduct , getIsApplyFor } from "@/api";
import "@/assets/css/quill-better-table.css";
import "@/assets/css/quill.snow.css";
import imageView from ".././imageView.vue";
export default {
  name: "ProductsDetail",

  components: {
    imageView
  },
  data () {
    return {
      userInfoweb: this.$store.state.system.userInfoweb,
      token: this.$store.state.system.token,
      loginFlag: false,
      qydm: '',
      productDetails: {},
      applyList: [],
      hotList: [],
      current: 1,
      totalPage: 0,
    }
  },
  created () {
  },
  mounted () {
    this.getDetails(this.$route.params.id);
    this.checkToken();
  },
  methods: {

    async getDetails (id) {
      const res = await getNeedsDetail({
        id: id,
      });
      if (res && res.data) {
        this.productDetails = res.data;
      }
    },
  
    goApply (id) {
      if(this.token&&this.userInfoweb&&(this.userInfoweb.type==5)){ //是否登金融机构端
        getIsApplyFor({productId : id}).then((res)=>{
          if(res.data){
            this.$confirm('你已经申请该产品，确定要再次申请产品吗？', '', {
              confirmButtonText: '继续申请',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
                this.getApplyProduct(id);
            }).catch(() => {
            });
          }else{
            this.getApplyProduct(id);
          }
        })
      }else{
          this.$confirm('是否登录金融机构账号？', '', {
            confirmButtonText: '登录',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$router.push({
              name: 'login',
              query: {
                type: 2,
              },
            });
          }).catch(() => {
          });
      }
    },

    async getApplyProduct(id){
      const params = {
        productId: id,
        qydm: this.qydm
      }
      const formData = new FormData();
      for (const key in params) {
        params[key] !== undefined && formData.append(key, params[key]);
      }
      let res = {};
      res = await applyProduct(formData);
      this.$baseMessage("申请成功！", "success");
    },

    changePage () {
      if (this.current == this.totalPage) {
        this.current = 1;
      } else {
        this.current++;
      }
      this.getHotList();
    },
    checkToken () {
      if (this.$store.state.system.userInfoweb && this.$store.state.system.userInfoweb.type == 4) {
        this.qydm = this.$store.state.system.userInfoweb.dm;
        this.loginFlag = true;
      } else {
        this.loginFlag = false;
      }
    },
    async getHotList () {
      const res = await getHotSells({
        size: 4,
        current: this.current
      });
      if (res && res.data) {
        this.hotList = res.data.records;
        if (!this.totalPage) {
          this.totalPage = Math.ceil(res.data.total / 4)
        }
      }
    },
  },
  
}
</script>
<style scoped>
.shadow {
  position: relative;
  box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
  padding: 25px 21px;
  min-height: 340px;
  background-color: #fff;
  border-radius: 16px;
}
.product-detail {
  display: flex;
}
.detail-left {
  display: inline;
  text-align: center;
}

.detail-left img {
  width: 160px;
  height: 160px;
  object-fit: contain;
  border: 1px solid gray;
  margin: auto;
}
.detail-right {
  flex: 1;
  font-size: 18px;
}

.product-name {
  font-size: 24px;
  font-weight: 700;
  color: #303133;
  margin-bottom: 28px;
  line-height: 1.2;
}

.info-list {
  display: flex;
  flex-direction: column;
}

.info-item {
  display: flex;
  align-items: center;
  font-size: 16px;
  margin-bottom: 18px;
}

.info-label {
  flex-shrink: 0;
  width: 200px;
  color: #909399;
  font-weight: 500;
}

.info-value {
  flex: 1;
  /* color: #3175ff; */
  /* font-weight: 600; */
  word-break: break-all;
}

.detail-btn {
   position: absolute;
  bottom: 25px;
  right: 30px;
  display: flex;
  justify-content: flex-end;
  
}

.detail-btn span {
   padding: 0 20px;
  color: white;
  display: flex;
  height: 44px;
  justify-content: center;
  align-items: center;
  gap: 3px;
  align-self: stretch;
  border-radius: 16px;
  background: radial-gradient(
      56.94% 56.32% at 50% 0%,
      #008bff 0%,
      #008bff00 100%
    ),
    radial-gradient(165.43% 73.9% at 50% 100%, #7157fe 0%, #7157fe00 100%), #07f;
  box-shadow: 0 0 7.9px 0 #fff inset, 0 5px 5px 0 #1366ec21;
  cursor: pointer;
}

.detail-btn span:hover {
  background: #2563eb;
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(49, 117, 255, 0.35);
}
.detail-word {
  width: 100%;
  margin-top: 25px;
  font-size: 16px;
  padding: 25px 21px;
  background-color: white;
  border-radius: 16px;
  box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
}
.detail-name {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 20px;
}
.detail-title {
  font-size: 18px;
  font-weight: bold;
  min-width: 90px;
  display: inline-block;
  padding-top: 5px;
}
.detail-text {
  font-size: 16px;
  line-height: 28px;
  display: inline-block;
}
.hot-product {
}

.title {
  font-size: 26px;
  font-weight: bold;
  text-align: center;
  margin: 35px 0;
  letter-spacing: 0.3px;
  position: relative;
}
.title-eng {
  color: #cecdcd;
  margin-left: 20px;
}
.hot-product .finanblock2 {
  display: inline-flex;
  justify-content: space-between;
  width: 90%;
  margin-left: 5%;
  height: 400px;
}
.hot-product .finanblock2 .applyamt {
  display: inline-block;
  width: 31%;
  height: 400px;
  background: url("../../assets/img/home/productBack.png") no-repeat;
  background-size: 100% 100%;
  text-align: center;
  font-size: 12px;
}
.changeTxt {
  position: absolute;
  font-size: 16px;
  color: gray;
  bottom: 0;
  right: 6%;
  cursor: pointer;
}
.apply-name {
  font-size: 18px;
  font-weight: bold;
  margin-top: 35px;
}
.apply-details1 {
  font-size: 16px;
  margin-top: 25px;
}
.apply-details2 {
  font-size: 20px;
  font-weight: bold;
  color: red;
  margin-top: 25px;
}
.apply-details3 {
  font-size: 16px;
  margin: 25px;
}
.apply-descripe {
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  width: 50%;
  height: 80px;
}
.apply-deadline {
  font-size: 16px;
  font-weight: bold;
  margin-top: 10px;
}
.apply-month {
  margin-top: 15px;
  font-size: 16px;
}
.apply-btn {
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 1px;
  background-color: #3175ff;
  width: 70%;
  color: white;
  padding: 15px 0;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  border-radius: 2%;
  margin-top: 25px;
  cursor: pointer;
}
.apply-btn-false {
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 1px;
  background-color: gray;
  width: 70%;
  color: white;
  padding: 15px 0;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  border-radius: 2%;
  margin-top: 25px;
}
@media screen and (max-width: 767px) {
  .list-item div {
    padding: 30px;
  }
}
</style>

